import(/* webpackMode: "eager", webpackExports: ["NoticeDialog"] */ "/vercel/path0/apps/web/src/components/ui/NoticeDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/sections/project/Project.tsx");
